import { render, staticRenderFns } from "./GrandesNumeros.vue?vue&type=template&id=79d38284&"
import script from "./GrandesNumeros.vue?vue&type=script&lang=js&"
export * from "./GrandesNumeros.vue?vue&type=script&lang=js&"
import style0 from "./GrandesNumeros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports